define([
    "jquery",
    "underscore",
    "marionette",
    "models/career_model",
    "behaviors/form_errors_behavior",
    "backbone.syphon",
    "jquery.fileupload",
    "holdon"
], function($, _, Marionette, Career, FormErrorsBehavior) {
    return Marionette.View.extend({
        el: '#content_layout',

        behaviors: {
            formErrors: {
                behaviorClass: FormErrorsBehavior
            }
        },

        ui:{
            'form': '#career_form',
            'full_name': '#full_name',
            'email': '#email',
            'phoneCountry': '#phone_country',
            'phoneArea': '#phone_area',
            'phoneRest': '#phone_rest',
            'resumeFile': '#resume_file',
            'resumeName': '#resume_name',
            'resume': '#resume',
            'coverLetterFile': '#cover_letter_file',
            'coverLetterName': '#cover_letter_name',
            'coverLetter': '#cover_letter',
            'agreementCheck': '#agreement_check',
            'applyBtn': '#apply_btn',
            'resumeBtn': '#resume_btn',
            'coverLetterBtn': '#cover_letter_btn',
            'captchaImage': 'captcha_image'
        },

        events:{
            'click @ui.applyBtn': 'applyNow',
            'click @ui.resumeBtn': 'uploadResume',
            'click @ui.coverLetterBtn': 'uploadCoverLetter'
        },

        initialize: function(){
            this.bindUIElements();

            this.model = new Career();

            this.initFileUpload(this.ui.resumeFile, 'resume');
            this.initFileUpload(this.ui.coverLetterFile, 'cover_letter');
        },

        initFileUpload: function($selector, type){
            var that = this;
            $selector.fileupload({
                url: '/rest_about_us/'+type,
                dataType: 'json',
                // File selected, put the original name in the textbox
                add: function(e, data){
                    HoldOn.open({
                        theme:"sk-fading-circle"
                    });
                    data.submit();
                },
                // Upload success, put the server-side name in the hidden input
                done: function(e, data){
                    type = type.replace(/(\_[a-z])/g, function($1){return $1.toUpperCase().replace('_','');}); // underscore to camelCases
                    that.ui[type+'Name'].val(data.files[0].name);
                    that.ui[type].val(data.jqXHR.responseJSON.file_path);

                    HoldOn.close();
                },
                // Upload failed, display error + remove name from textbox
                fail: function(e,data){
                    var errors = {};
                    errors[type] = data.jqXHR.responseJSON.error_msg;

                    that.ui[type+'Name'].val('');
                    that.ui[type].val('');

                    HoldOn.close();

                    that.triggerMethod('show:errors', errors);
                }
            });
        },

        applyNow: function(e){
            var that = this;
            if(e) e.preventDefault();
            this.triggerMethod('hide:errors');

            var formData = Backbone.Syphon.serialize(this);

            this.model.set(formData);

            if(this.captchaCheck){
                this.model.set('captcha_check', this.captchaCheck);
            }

            var errors = this.model.validate();

            if(!formData['captcha_code']){
                errors = _.extend({}, errors, {captcha_code: 'You must complete the captcha.'});
            }

            if(_.size(errors) < 1){
                this.model.save(null, {
                    type: 'POST',
                    success: function(model, res){
                        that.ui.form[0].reset();
                        that.ui.captchaImage.attr('src', '/assets/libs/securimage/securimage_show.php?' + Math.random());
                        that.triggerMethod('show:success');
                    },
                    error: function(model, error){
                        if(error.responseJSON.captcha_check){
                            that.captchaCheck = error.responseJSON.captcha_check;
                        }
                        delete error.responseJSON.captcha_check;
                        that.triggerMethod('show:errors', error.responseJSON);
                    }
                });
            }else{
                this.triggerMethod('show:errors', errors);
            }
        }
    });
});



//////////////////
// WEBPACK FOOTER
// ./assets/common/main/js/views/w/about_us/career_view.js
// module id = 2
// module chunks = 0